<pos-stepper #cdkStepper (selectionChange)="handleChangeStep($event)">
  <cdk-step
    label="Pre Aprobación"
    [stepControl]="preApprovalForm"
    [optional]="false"
    *ngIf="showPreApprovalForm()"
  >
    <app-customer-pre-approval-form
      [preApprovalForm]="preApprovalForm"
      [currentCustomer]="this.currentCustomer"
      [homeTypes]="this.homeTypes"
      (preApprovalChange)="handlePreApprovalInfoChange($event, cdkStepper)"
      #customerPreApprovalFormComponent
    >
    </app-customer-pre-approval-form>
  </cdk-step>
  <cdk-step
    label="Producto de Interes"
    [optional]="false"
    [stepControl]="productSelectionForm"
  >
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-12">
          <app-pos-product-list
            (selectedProductChange)="handleSelectedProductChange($event)"
          ></app-pos-product-list>
        </div>
      </div>
    </div>
  </cdk-step>
  <cdk-step
    label="Planes Pre Aprobados"
    [stepControl]="preApprovalForm"
    [optional]="false"
  >
    <app-customer-credit-plans
      [currentCustomer]="this.currentCustomer"
      [currentCustomerCreditStatus]="this.currentCustomerCreditConditions"
      [creditPlans]="plans"
      [selectedProduct]="this.selectedProduct"
      [selectedSeller]="this.selectedSeller"
      [preApprovalForm]="preApprovalForm"
      (preApproveCreditPlan)="handlePreApproveCreditPlan($event)"
      (quotationPlanClick)="handleClickOnQuotationPlan($event)"
      #customerCreditPlansComponent
    >
    </app-customer-credit-plans>
  </cdk-step>
</pos-stepper>
